import React, { memo } from "react";
import type { Clip } from "../../../types";
import { ClipElement } from "./ClipElement";

export const TrackContent = memo(function TrackContent({
    trackId,
    isVisible,
    isBeingDragged,
    clips,
    zoom,
    toolMode,
    onSelectClip,
    selectedClipId,
    onClipDragStart,
    onZoomTrackMouseDown,
    onDoubleClick,
    onDeleteClip
}: {
    trackId: string;
    isVisible: boolean;
    isBeingDragged: boolean;
    clips: Clip[];
    zoom: number;
    toolMode?: 'move' | 'cut';
    onDeleteClip: (clipId: string) => void;
    onSelectClip: (id: string | null, element: HTMLElement | null) => void;
    selectedClipId: string | null;
    onClipDragStart: (e: React.MouseEvent, clip: Clip, action: string) => void;
    onZoomTrackMouseDown?: (e: React.MouseEvent) => void;
    onDoubleClick?: (clip: Clip) => void;
}) {
    return (
        <div
            data-track-id={trackId}
            className={`relative h-14 mb-2 ${!isVisible ? 'opacity-50' : ''} ${isBeingDragged ? 'opacity-30' : ''} ${trackId === 'z1' ? 'cursor-crosshair' : ''}`}
            onMouseDown={trackId === 'z1' ? onZoomTrackMouseDown : undefined}
        >
            {clips.map(clip => (
                <ClipElement
                    key={clip.id}
                    clip={clip}
                    zoom={zoom}
                    toolMode={toolMode}
                    onSelectClip={onSelectClip}
                    selectedClipId={selectedClipId}
                    onClipDragStart={onClipDragStart}
                    onDoubleClick={onDoubleClick}
                    onDeleteClip={onDeleteClip}
                />
            ))}
        </div>
    );
});
